import {React,useReducer,useEffect} from 'react'
import { Moviename } from '../Component/Fetcher';
import { useNavigate } from 'react-router-dom'



const initaistate ={
    data :[],
    error:'',
    loading :true
  }
  
  
  const reducer=(state,action)=>{
  switch(action.type){
    case 'success':
      return{
        ...state,
        data :action.payload,
        loading: false
      }
      case 'failed':
        return{
          ...state,
          data :[],
          error : action.errormessage,
          loading :false
        }
  }
  }
  
  
  

const Nav = () => {
     const[productdata,dispatch]= useReducer(reducer,initaistate)
     const navigate = useNavigate()


       useEffect(()=>{
         Moviename({dispatch})
       },[])
     
       const render=()=>{
        return productdata.data.map(data=>(
        <li id='list' onClick={()=>navigate(`/Categoriemovie/${data.id}`)} key={data.id}>{data.title}</li>
        ))
        
        
        
        }

    
  return (
    <div>


        {productdata.loading?'loading': render()}
        {productdata.error?productdata.error :' '}

        
        </div>
    
        

  )
}

export default Nav